export enum ContactCategoryEnum {
    Accountable = 'ASST', // Aansprakelijk stellen
    CarInsurance = 'AUTO', // Autoverzekering
    Damage = 'SCHD', // Schade
    MyZone = 'ACNT', // Verzekeringsmap/inloggen
    AccidentDeath = 'OVRL', // Overlijden doorgeven
    Bicycle = 'FIET', // Fietsverzekering
}
